import { useState, useCallback } from "react";
// Turnstile disabled — rate limiting is sufficient for now. Re-enable if spam becomes an issue.
// import { TurnstileWidget, resetTurnstile } from "./TurnstileWidget";

export function SubscribeForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");
  // const [turnstileToken, setTurnstileToken] = useState("");

  const handleSubmit = useCallback(async () => {
    if (!email.trim()) return;

    setStatus("loading");
    setErrorMsg("");

    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), turnstileToken: "" }),
      });

      const data = await res.json() as { success?: boolean; error?: string };

      if (res.ok && data.success) {
        setStatus("success");
      } else {
        setStatus("error");
        setErrorMsg(data.error ?? "Something went wrong. Please try again.");
      }
    } catch {
      setStatus("error");
      setErrorMsg("Network error. Please try again.");
    }
  }, [email]);

  return (
    <div className="max-w-md">
      {status === "success" ? (
        <>
          <p className="text-sm font-[family-name:var(--font-mono)] text-emerald-500 mb-4">
            You're subscribed! We'll let you know when we publish new articles.
          </p>
          <button
            onClick={() => { setStatus("idle"); setEmail(""); }}
            className="text-xs font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] hover:text-[var(--color-fg)] transition-colors cursor-pointer"
          >
            Subscribe another email →
          </button>
        </>
      ) : (
        <>
          <div className="flex gap-3">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              placeholder="you@company.com"
              className="flex-1 px-4 py-3 border border-[var(--color-border)] bg-transparent text-[var(--color-fg)] font-[family-name:var(--font-mono)] text-sm placeholder:text-[var(--color-fg-tertiary)] focus:outline-none focus:border-[var(--color-fg-secondary)] transition-colors"
            />
            <button
              onClick={handleSubmit}
              disabled={status === "loading"}
              className="px-5 py-3 text-sm font-medium bg-[var(--color-fg)] text-[var(--color-bg)] rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap disabled:opacity-50"
            >
              {status === "loading" ? "..." : "Subscribe"}
            </button>
          </div>
          {status === "error" && (
            <p className="text-[11px] font-[family-name:var(--font-mono)] text-red-500 mt-2">{errorMsg}</p>
          )}
          <p className="text-[10px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] mt-3">
            We'll only email you about new articles. See our{" "}
            <a href="/legal#privacy" className="hover:text-[var(--color-fg)] transition-colors underline">privacy policy</a>.
          </p>
        </>
      )}
      {/* <TurnstileWidget onToken={setTurnstileToken} /> */}
    </div>
  );
}
